import { AfterLoadEventHandler, CreateOptionsParams, ISpecializedCombo, useCombo } from '@hooks/useCombo';
import { MenuItem } from '@material-ui/core';
import { useRetornoService } from '@services/RetornoService';
import { useThemeColor } from '@themes/Colors';
import { KeyOfEnum } from '@utils/TypeHelpers';
import React from 'react';

export enum EnumRetornoItemStatus {
    None = 0,
    Confirmado = 1,
    Liquidado = 2,
    Recusa = 3,
    BaixaAutomatica = 4
}

export interface IRetornoItemStatus {
    retornoItemStatusId: EnumRetornoItemStatus
    nome: string
    ativo: string
}

export type IComboRetornoItemStatus = ISpecializedCombo<IRetornoItemStatus>;

export function useRetornoItemStatusCombo (initialValue?: EnumRetornoItemStatus) : IComboRetornoItemStatus {
    const combo = useCombo<IRetornoItemStatus>({
        value: initialValue
    });

    const retornoService = useRetornoService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((retornoItem, index) => {
            return <MenuItem key={index} value={retornoItem.retornoItemStatusId}>{params?.prefix}{retornoItem.nome}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IRetornoItemStatus>) => {
        combo.load(retornoService.listarItemStatusAtivos, afterLoad)
    }, [combo, retornoService.listarItemStatusAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}

export function useRetornoItemStatusColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<EnumRetornoItemStatus, string> = React.useMemo(() => ({
        [EnumRetornoItemStatus.None]: "",
        [EnumRetornoItemStatus.Confirmado]: themeColor.status.azul,
        [EnumRetornoItemStatus.Liquidado]: themeColor.status.verde,
        [EnumRetornoItemStatus.Recusa]: themeColor.status.vermelho,
        [EnumRetornoItemStatus.BaixaAutomatica]: themeColor.status.laranja
    }), [themeColor.status.azul, themeColor.status.laranja, themeColor.status.verde, themeColor.status.vermelho]);

    return React.useMemo(() => map, [map]);
}